export class State<T> {
  error: Record<string, any> | null = null;
  success = false;
  isLoading = false;
  dataItem: Record<string, any> = {} as T;
}
